﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListBestellungAdbChoose extends GuiListGeneric {

    constructor() {
        super("BestellungAdb");
    }

    protected clickRow(e: JQuery.ClickEvent) {
        e.preventDefault();
        const bestellungId = $("#BestellungId").val();
        const id = $(e.target).closest("div.erz-list-element").data("id") as string;
        const selectUrl = $("div.erz-list").data("select-url") as string;
        const url = `${selectUrl}?bestellungId=${bestellungId}&adbId=${id}`;
        this.gotoUrl(url);
    }
}
